<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-card>
        <h4>{{ $t('global.notifications_list_title') }}</h4>
        <div v-if="spinners.contentIsLoading" class="text-center">
          <b-spinner type="grow" variant="primary"/>
        </div>
        <div v-else>
          <b-row>
            <b-col cols="12">
              <b-table class="table-sm text-center" responsive outlined hover head-variant="light"
                       :fields="tableFields" :items="tableItems" :tbody-tr-class="rowClass"
                       @row-clicked="open"/>
            </b-col>
          </b-row>
          <b-row>
            <!--Paginator-->
            <b-col cols="12" v-if="tableItems.length">
              <Pagination :data="listPaginator" :limit="5" @pagination-change-page="onPageChange"/>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import statuses from '@/store/statuses';
import forEach from 'lodash.foreach';
import { mapGetters, mapActions } from 'vuex';
import Pagination from 'laravel-vue-pagination';
import VT from '@/store/types';

export default {
  mounted() {
    this.getData();
  },
  props: ['page'],
  data() {
    return {
      spinners: {
        contentIsLoading: true,
      },
      tableFields: [
        { key: 'created_at', label: this.$t('global.created_at') },
        { key: 'type', label: this.$t('global.type') },
        { key: 'title', label: this.$t('global.title') },
        { key: 'message', label: this.$t('global.message') }
      ],
      tableItems: []
    };
  },
  components: {
    Pagination
  },
  computed: {
    ...mapGetters('Notifications', [
      'notifications',
      'notificationsReadUpdate',
      'routeMap'
    ]),

    listPaginator() {
      return this.notifications.data.meta;
    },
    list() {
      return this.notifications;
    },
  },
  watch: {
    page: 'getData',
    listPaginator: {
      handler: function () {
        if (this.listPaginator && this.listPaginator.last_page < this.page) {
          this.onPageChange(this.listPaginator.last_page);
        }
      },
      deep: true
    },
    list: {
      handler: function () {
        this.fillData();
      },
      deep: true
    },
  },
  methods: {
    ...mapActions('Notifications', [
      VT.NOTIFICATIONS,
      VT.NOTIFICATION_READ_UPDATE,
    ]),
    fillData() {
      const result = [];
      if (this.list['status'] === statuses.LOADED) {
        forEach(this.list.data.data, (item) => {
          result.push({
            id: item['id'],
            externalId: item['externalId'],
            created_at: item['createdAt'],
            type: item['type'],
            title: item['title'],
            message: item['message'],
            tdClass: !item['readAt'] ? 'font-weight-bold' : null
          });
        });
      }
      this.tableItems = result;
      this.spinners.contentIsLoading = false;
    },
    getData() {
      this.NOTIFICATIONS(this.page);
    },
    onPageChange(page) {
      if (!page) {
        page = this.page;
      }
      if (page !== this.page) {
        this.$router.push({ name: 'Notifications', params: { page } });
      }
    },
    open(row) {
      this.markRead(row['id']);
      this.goto(row);
    },
    markRead(id) {
      this.NOTIFICATION_READ_UPDATE({ type: 1, ids: [id] });
    },
    goto(row) {
      if (row['externalId']) {
        this.$router.push({
          name: this.routeMap[row['type']],
          params: {
            id: row['externalId']
          },
        });
      }
    },
    rowClass(item) {
      return item.tdClass;
    }
  }
};

</script>

<style scoped>
</style>
